import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BiensImmobsBiensImmobs } from 'app/services/biens-immobs/biens-immobs.service';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';

@Component({
  selector: 'app-liste-biens',
  templateUrl: './liste-biens.component.html',
  styleUrls: ['./liste-biens.component.scss']
})
export class ListeBiensComponent implements OnInit {

  public biens:any
  dataSource = new MatTableDataSource();
  constructor(private MeilleuresbiensService:MeilleursBiensService) { }

  getData(){
    this.MeilleuresbiensService.getListMeilleuresBiens().subscribe(data =>{
      this.biens=data
      console.log("this is my data",this.biens)
    })
  }
    ngOnInit(): void {
      this.MeilleuresbiensService.refreshNedeed.subscribe(() => this.getData());
      this.getData()
    }
    SupprimerBiensImmobs(BiensImmobs: any) {
      this.MeilleuresbiensService.deleteMBiens(BiensImmobs.id).subscribe((response: any) => {
  
  
        console.log(this.dataSource.data);
  
  
      });
      setTimeout(() => {
        this.getData()
      }, 500)
  
    }
  
}
